import Typography from "@portal/components/atoms/v2/typography";
import { OnAgreementNameChange } from "../../handlers";
import { INameInputOptionsProps } from "../types";
import Input from "@portal/components/atoms/v2/input";
import React from "react";

export const NameInputOptions = ({ name, header, setAgreementName, dispatch }: INameInputOptionsProps) => (
  <>
    <div className="flex mt-2">
      <Typography variant="Bold">{header}</Typography>
    </div>
    <div className="border border-blueLight rounded-md">
      <Input
        type="text"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => OnAgreementNameChange(e.target.value, setAgreementName, dispatch)}
        value={name}
      />
    </div>
  </>
);
